const ArrowRight = ({ className = "" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 100 100" fill="none" aria-hidden="true">
    <path
      d="M83.25 49.9535L86.1933 47.0102L89.1367 49.9535L86.1933 52.8968L83.25 49.9535ZM20.8125 54.116C18.5136 54.116 16.65 52.2524 16.65 49.9535C16.65 47.6546 18.5136 45.791 20.8125 45.791V49.9535V54.116ZM58.275 24.9785L61.2183 22.0352L86.1933 47.0102L83.25 49.9535L80.3067 52.8968L55.3317 27.9218L58.275 24.9785ZM83.25 49.9535L86.1933 52.8968L61.2183 77.8718L58.275 74.9285L55.3317 71.9852L80.3067 47.0102L83.25 49.9535ZM83.25 49.9535V54.116H20.8125V49.9535V45.791H83.25V49.9535Z"
      fill="currentColor"
    />
  </svg>
);

export default ArrowRight;
